dmx.Component('f7-page', {
  
  initialData: {
    route: null,
  },

});